import { FC } from 'react';
import ProMentions, { MentionsProps, getMentions } from './mentions';
import ProMentionsOption, { MentionsOptionProps } from './option';

interface MentionsConfig {
  prefix?: string | string[];
  split?: string;
}
interface MentionsEntity {
  prefix: string;
  value: string;
}
export type IMentionsComponent = FC<
  MentionsProps & React.RefAttributes<HTMLElement>
> & {
  Option: FC<MentionsOptionProps>;
  getMentions: (value: string, config?: MentionsConfig) => MentionsEntity[];
};

const TransMentions = ProMentions as IMentionsComponent;
TransMentions.Option = ProMentionsOption;
TransMentions.getMentions = getMentions;

export default TransMentions;
